import { Getgot, Item } from '@/api/ms-item/services/interfaces/Item';

export default (item: Item, username: string): Getgot | undefined => {
  /**
   * Returns the getgot item for the current username, or undefined
   */
  return item.getgot?.filter(getGot => getGot.actor.username === username)[0];
};
